import customSettings from '@/model/userCustomSettings';
import store from '@/store';

export default {
  getFavorites(category) {
    return store.state.auth.user?.customSettings?.favorites?.[category] ?? [];
  },
  isFavorite(category, id) {
    return this.getFavorites(category).includes(id);
  },
  toggleFavorite(category, id) {
    const favorites = store.state.auth.user?.customSettings?.favorites ?? {};
    favorites[category] ??= [];

    if (favorites[category].includes(id)) {
      favorites[category] = favorites[category].filter(f => f !== id);
    } else {
      favorites[category] = [...favorites[category], id];
    }

    customSettings.set({ favorites });
  },
};
